import {forkJoin, Observable} from 'rxjs';
import {map} from 'rxjs/operators';

import {
  ISinglePlate,
  ISingleVoting,
} from '../features/election-single/store/types';
import {
  IElection,
  IInputVoting,
  IPlate,
  IPlateDetail,
  IVoting,
} from '../features/election/store/types';
import {IResponse20x, IResponseCollection, RxAxios} from '../shared';

export class ElectionService {
  constructor(protected api: RxAxios) {}

  public loadModel(): Observable<IElection> {
    return this.api
      .get<IResponse20x>('/mod/participants/elections/info')
      .pipe(map(result => result.data));
  }

  public loadPlates(): Observable<IPlate[]> {
    return this.api
      .get<IResponseCollection>(`/mod/participants/plates`, {
        include: 'competitors',
      })
      .pipe(map(result => result.data));
  }

  public loadPlateDetailByUuid(uuid: string): Observable<IPlateDetail> {
    return this.api
      .get<IResponse20x>(`/mod/participants/plates/${uuid}`)
      .pipe(map(result => result.data));
  }

  public loadManyPlateDetailByUuid(
    uuids: string[]
  ): Observable<ISinglePlate[]> {
    return forkJoin(uuids.map(uuid => this.loadPlateDetailByUuid(uuid))).pipe(
      map((plates: IPlateDetail[]) => {
        return plates.map(plate => this.transformPlateToSinglePlate(plate));
      })
    );
  }

  // TODO: refactor vote()
  public vote(data: IInputVoting): Observable<IVoting> {
    return this.api
      .post<IResponse20x>(`/mod/participants/vote`, data)
      .pipe(map(result => result.data));
  }

  public singleVote(data: IInputVoting[]): Observable<ISingleVoting[]> {
    return this.api
      .post<IResponse20x>(`/mod/participants/vote-single`, data)
      .pipe(map(result => result.data));
  }

  private transformPlateToSinglePlate(plate: IPlateDetail): ISinglePlate {
    return {
      plate: plate.plate,
      competitors: plate.competitors.map(item => ({
        ...item,
        checked: false,
        id: item.id,
      })),
      invalid: plate.plate.configs.choice_min !== 0,
    };
  }
}



// WEBPACK FOOTER //
// ./src/services/election-service.ts